import { render, staticRenderFns } from "./dispatchHousekeeping.vue?vue&type=template&id=40d42b8a"
import script from "./dispatchHousekeeping.vue?vue&type=script&lang=js"
export * from "./dispatchHousekeeping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports